<script setup>
import IconPrevious from '../icons/IconPrevious.vue';
import IconNext from '../icons/IconNext.vue';

const props = defineProps({
  pagination: {
    type: Object,
    required: true,
  },
  from: {
    type: Number,
    required: true,
  },
  to: {
    type: Number,
    required: true,
  },
  checkedItems: {
    type: Number,
    default: 0,
  },
  haveCheckedItems: Boolean,
});
const emit = defineEmits(['next', 'previous']);

const handlePrevious = () => {
  if (props.pagination.currentPage === 1) return;
  emit('previous');
};

const handleNext = () => {
  if (props.to === props.pagination.total) return;
  emit('next');
};
</script>

<template>
  <div class="simple__pagination">
    <div
      class="simple__pagination__inner"
      :class="{ active: haveCheckedItems }"
    >
      <span
        v-if="checkedItems"
        class="simple__pagination__inner--checked"
      >
        {{ checkedItems }}
      </span>

      <div class="simple__pagination__inner--content">
        <span
          class="simple__pagination__inner--content--numbers"
        >
          {{ from }}&ndash;{{ to }} of {{ pagination.total }}
        </span>
        <div class="simple__pagination__inner--content--buttons">
          <span
            role="button"
            aria-label="Previous Page"
            :class="{ disabled: pagination.currentPage === 1 }"
            @click="handlePrevious"
          >
            <icon-previous />
          </span>
          <span
            role="button"
            aria-label="Next Page"
            :class="{ disabled: to === pagination.total }"
            @click="handleNext"
          >
            <icon-next color="#000000" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.simple__pagination {
  z-index: 11;

  &__inner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 8px;
    height: 46px;
    padding: 5px 5px 5px 8px;
    margin-right: 10px;
    background-color: #FFFFFF;
    border-radius: 1000px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    transition: all 200ms cubic-bezier(0.2, 0, 0, 1);

    &.active {
      padding-left: 45px;
    }

    &--checked {
      position: absolute;
      left: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      padding: 6px;
      background-color: #F3DEFF;
      color: #1E1A1F;
      font-size: 14px;
      border-radius: 50%;
    }

    &--content {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 8px;
      padding: 3px;

      &--numbers {
        margin-left: 6px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #1E1A1F;
      }

      &--buttons {
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 32px;
          height: 32px;
          padding: 6px;
          border-radius: 50%;
          cursor: pointer;
          transition: background-color 150ms linear;

          &.disabled {
            opacity: 0.3;
            cursor: not-allowed;
          }

          &:hover:not(.disabled) {
            background-color: #1d1b2014;
          }
        }
      }
    }
  }
}
</style>
